/* eslint-disable import/prefer-default-export */
import { InsightViewOption } from 'enums'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import CountType, { CountTypeStrings } from '../enums/CountType'
import Measure, { MeasureStrings } from '../enums/Measure'
import AnalysisType, { AnalysisTypeStrings } from '../enums/AnalysisType'

export const getMeasureByCountTypeAndAnalysisType = (
  countType: CountTypeStrings,
  analysisType: AnalysisTypeStrings
): MeasureStrings => {
  switch (countType) {
    case CountType.MENTIONS:
      return Measure.MENTIONS
    case CountType.POSTS:
      return Measure.POSTS
    case CountType.AUTHORS:
      switch (analysisType) {
        case AnalysisType.SW_DEMOGRAPHIC:
        case AnalysisType.AM_DEMOGRAPHIC:
        case AnalysisType.SW_BENCHMARK:
        case AnalysisType.AM_BENCHMARK:
        case AnalysisType.SW_GEOGRAPHY:
        case AnalysisType.AM_GEOGRAPHY:
        case AnalysisType.AM_LANGUAGE:
        case AnalysisType.SW_LANGUAGE:
        case AnalysisType.SW_POST_ACTIVITY:
        case AnalysisType.AM_POST_ACTIVITY:
        case AnalysisType.SW_CONVERSATION:
        case AnalysisType.SW_LIKES_AND_DISLIKES:
        case AnalysisType.SW_SIDE_BY_SIDE:
          return Measure.POSTS
        case AnalysisType.AM_THINGS:
        case AnalysisType.AM_CONVERSATION:
        case AnalysisType.AM_SENTIMENT:
        case AnalysisType.AM_LIKES_AND_DISLIKES:
          return Measure.MENTIONS
        default:
          throw new Error(`Cannot get Measure by Count Type for: ${analysisType}`)
      }
    default:
      throw new Error(`Unknown Count Type: ${countType}`)
  }
}

export const getMeasureByViewOptionAndCountType = (
  viewOption: InsightViewOptionStrings,
  countType: CountTypeStrings
) => {
  let measure

  switch (viewOption) {
    case InsightViewOption.MOST_ENGAGEMENT:
      switch (countType) {
        case CountType.POSTS:
          measure = Measure.ENGAGEMENTS
          break
        case CountType.MENTIONS:
        default:
          measure = Measure.ENGAGEMENTS_MENTIONS
      }
      break
    case InsightViewOption.MOST_MENTIONS:
      switch (countType) {
        case CountType.POSTS:
          measure = Measure.POSTS
          break
        case CountType.MENTIONS:
        default:
          measure = Measure.MENTIONS
      }
      break
    case InsightViewOption.MOST_FOLLOWERS:
      switch (countType) {
        case CountType.POSTS:
          measure = Measure.FOLLOWERS_POSTS
          break
        case CountType.MENTIONS:
        default:
          measure = Measure.FOLLOWERS
      }
      break
    default:
      throw new Error(`No supported view option: ${viewOption}`)
  }

  return measure
}
